import Box from "@/components/Box";
import { ExternalTextLink, InternalTextLink } from "@/components/Links";
import { REGENERUS_PRIVACY_URL, REGENERUS_TERMS_OF_USE_URL } from "@/core/urls";
import Tick from "@/images/tick.svg?react";
import Center from "@/tpo/Center";
import Checkbox from "@/tpo/Checkbox";
import ControlledFormField from "@/tpo/ControlledFormField";
import FormControl from "@/tpo/FormControl";
import Group from "@/tpo/Group";
import { Error } from "@/tpo/InputWrapper";
import Stack from "@/tpo/Stack";
import ButtonV2 from "@/v2/Buttons";

import GreenTick from "../icons/greenTick";
import RedCross from "../icons/redCross";

export default function ConfirmAndSubmit({ api = {} }) {
  return (
    <Stack bg="white" pt={40} pb={80} px={[20, 20, 80]} gap={40} borderRadius={5}>
      <Box fontFamily="gilroyBold" fontSize={[28, 28, 36]}>
        Confirm & submit
      </Box>
      <FormControl
        fields={
          <>
            <ControlledFormField
              label={
                <ul>
                  I acknowledge that support is provided in the following areas:
                  <Group as="li" gap={8} alignItems="center">
                    <GreenTick />
                    Result interpretation
                  </Group>
                  <Group as="li" gap={8} alignItems="center">
                    <GreenTick />
                    Test selection and application
                  </Group>
                  <Group as="li" gap={8} alignItems="center">
                    <GreenTick />
                    Follow-up testing strategy
                  </Group>
                  <Group as="li" gap={8} alignItems="center">
                    <GreenTick />
                    Understanding broader testing options
                  </Group>
                  <Group as="li" gap={8} alignItems="center">
                    <Center width={24} height={24}>
                      <RedCross />
                    </Center>
                    Specific supplement protocols
                  </Group>
                  <Group as="li" gap={8} alignItems="center">
                    <Center width={24} height={24}>
                      <RedCross />
                    </Center>
                    Dosage recommendations
                  </Group>
                  <Group as="li" gap={8} alignItems="center">
                    <Center width={24} height={24}>
                      <RedCross />
                    </Center>
                    Case-specific clinical advice
                  </Group>
                </ul>
              }
              name="acknowledgeSupport"
              Component={Checkbox}
              styles={{
                labelProps: {
                  fontSize: 14,
                  lineHeight: "24px"
                },
                wrapperProps: {
                  alignItems: "flex-start"
                },
                checkbox: {
                  size: "lg"
                }
              }}
            />
          </>
        }
      />
      <FormControl
        fields={
          <>
            <ControlledFormField
              label={
                <>
                  By submitting this form, I confirm that I have read and agree to the{" "}
                  <InternalTextLink href={REGENERUS_TERMS_OF_USE_URL}>
                    Terms of Service
                  </InternalTextLink>{" "}
                  and{" "}
                  <InternalTextLink href={REGENERUS_PRIVACY_URL}>Privacy Policy</InternalTextLink> ,
                  and I consent to receive health-related news, exclusive promotions, and product
                  updates from Regenerus Lab by email.
                </>
              }
              name="acceptTerms"
              Component={Checkbox}
              styles={{
                labelProps: {
                  fontSize: 14,
                  lineHeight: "24px"
                },
                wrapperProps: {
                  alignItems: "flex-start"
                },
                checkbox: {
                  size: "lg"
                }
              }}
            />
          </>
        }
      />
      <ButtonV2 color="dark" withChevron size={["sm", "sm", "md"]} mx="auto">
        Submit
      </ButtonV2>
      {!!api.nonFieldError && <Error error={api.nonFieldError} />}
    </Stack>
  );
}
